// PolyFills / externals
import 'element-closest';
import 'whatwg-fetch';
import 'weakmap-polyfill';
import 'custom-event-polyfill';
import 'classlist-polyfill';
import focusWithin from 'focus-within';
import Promise from 'es6-promise';
import 'nodelist-foreach-polyfill';
import findIndex from 'array.prototype.findindex';



// Modules
import helpers from './modules/helpers.js';
import enhance from './modules/enhance.js';
import forms from './modules/forms.js';
import equalheight from './modules/equalheight.js';
import navigation from './modules/navigation.js';
import breadcrumb from './modules/breadcrumb.js';
import location from './modules/location.js';
import scrollTo from './modules/scrollTo.js';
import message from './modules/message.js';
import video from './modules/video.js';
import videoBg from './modules/video-bg.js';
import tables from './modules/tables.js';
import tabs from './modules/tabs.js';
import expander from './modules/expander.js';
import clickable from './modules/clickable.js';
import carousel from './modules/carousel.js';
import slider from './modules/slider.js';
import cards from './modules/cards.js';
import profiles from './modules/profiles.js';
import autocomplete from './modules/autocomplete.js';
import gallery from './modules/gallery.js';
import pagedTabs from './modules/paged-tabs.js';
import paralax from './modules/paralax.js';
import reveal from './modules/reveal.js';
import warning from './modules/opco-warning.js';
import overlay from './modules/overlay.js';
import tracking from './modules/tracking.js';
import locationSelectorModal from './modules/location-selector-modal.js';
import tooltip from './modules/tooltip.js';
import masterDetail from './modules/master-detail';
import lazyImages from './modules/lazy-images';
import mobileStickyNav from './modules/mobileStickyNav.js';
import faqAccordion from './modules/faq-accordion.js';

findIndex.shim();

// polyfill promise
if (!window.Promise) {
  window.Promise = Promise;
}

// focus within pollyfill
focusWithin(document);

// set up namespace
const spirax = window.spirax || {
  helpers,
  enhance,
  forms,
  equalheight,
  navigation,
  breadcrumb,
  location,
  scrollTo,
  message,
  video,
  videoBg,
  tables,
  tabs,
  expander,
  clickable,
  carousel,
  slider,
  cards,
  profiles,
  autocomplete,
  gallery,
  pagedTabs,
  paralax,
  reveal,
  warning,
  overlay,
  tracking,
  locationSelectorModal,
  tooltip,
  masterDetail,
  lazyImages,
  mobileStickyNav,
  faqAccordion,
};

// globals to window
window.spirax = spirax;

// run the code.
document.addEventListener('DOMContentLoaded', () => {
  Object.keys(spirax).forEach((module) => {
    if (typeof spirax[module].init === 'function') {
      try {
        spirax[module].init();
      } catch (error) {
        console.error(error);
      }
    }
  });
});
